export class SessionNotFoundException extends Error {
  constructor(message) {
    super(message);
  }
}